import { forwardRef } from 'react';
import { FormControl, FormLabel, SwitchProps, FormHelperText } from '@mui/material';
import { Controller, Control } from 'react-hook-form';
import styles from './index.module.scss';
import SwitchField from '.';
import classNames from 'classnames';

interface ISwitchProps extends SwitchProps {
  control?: Control;
  label?: string;
  explanationText?: string;
  required?: boolean;
  error?: boolean;
  message?: string;
  helperMessage?: string;
  classes?: {
    root?: string;
    label?: string;
    explanationText?: string;
  };
}
export default forwardRef((props: ISwitchProps, ref) => {
  const {
    onChange,
    control,
    name,
    label,
    explanationText,
    value,
    defaultValue,
    required,
    error,
    helperMessage,
    classes,
    ...switchProps
  } = props;

  return (
    <FormControl
      className={classNames('flex flex-row items-center mt-4', classes?.root)}
      error={error ?? false}
    >
      <Controller
        rules={{
          required: {
            value: required ?? false,
            message: 'This field is required',
          },
        }}
        render={({ field }) => (
          <SwitchField
            inputRef={ref}
            {...field}
            checked={value || field.value}
            onChange={onChange || field.onChange}
            {...switchProps}
          />
        )}
        name={name ?? ''}
        defaultValue={Boolean(defaultValue)}
        control={control}
      />
      <FormLabel
        className="text-sm text-neutrals-n-400"
        classes={{
          root: classNames(styles.label, classes?.label),
          focused: styles.focused,
        }}
      >
        <div>
          {label ?? ''}
          {required ? <span className={styles.required}>*</span> : null}
        </div>
        {explanationText ? (
          <div
            className={classNames('color-disabled  font-semibold', classes?.explanationText)}
          >
            {explanationText}
          </div>
        ) : null}
      </FormLabel>
      {helperMessage ? <FormHelperText>{helperMessage}</FormHelperText> : null}
    </FormControl>
  );
});
